// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Team from './pages/team'; // Capital T
import Layout from './Layout';
import Home from './pages/Home';
import MemberProfile from './pages/MemberProfile';
import Services from './pages/Services';
import FamilyLaw from "./pages/FamilyLaw";
import WillsEstate from "./pages/WillsEstate";
import RealEstate from "./pages/RealEstate";
import ImmigrationLaw from "./pages/ImmigrationLaw.js";
import CivilLitigation from "./pages/CivilLitigation";
import PersonalInjury from "./pages/PersonalInjury";
import EmploymentLaw from "./pages/EmploymentLaw";
import CommercialLaw from "./pages/CommercialLaw";

import ContactUs from './pages/ContactUs';
import ThankYou from './pages/ThankYou'; 
import Blog from './pages/Blog.js';


function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        {/* Wrap everything in your Layout so header/footer are always visible */}
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="team" element={<Team />} />
          <Route path="services" element={<Services />} />
          <Route path="contact" element={<ContactUs />} />
          <Route path="our-team" element={<Team />} />
          <Route path="our-team/:id" element={<MemberProfile />} />
          <Route path="blog" element={<Blog />} />
           <Route path="thank-you" element={<ThankYou />} />
             <Route path="/services/family-law" element={<FamilyLaw />} />
        <Route path="/services/wills-estate" element={<WillsEstate />} />
        <Route path="/services/real-estate" element={<RealEstate />} />
        <Route path="/services/immigration-law" element={<ImmigrationLaw />} />
        <Route path="/services/civil-litigation" element={<CivilLitigation />} />
        <Route path="/services/personal-injury" element={<PersonalInjury />} />
        <Route path="/services/employment-law" element={<EmploymentLaw />} />
        <Route path="/services/Commercial-Law" element={<CommercialLaw />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
